import filter from 'lodash/filter';

export const inheritedInclusions = (propertyInclusionSets, inclusionSet, setInclusions) => {
  let newInclusionSet = inclusionSet;
  if (newInclusionSet?.parentInclusionSetId) {
    filter(propertyInclusionSets, (inclusionSet) => {
      if (inclusionSet._key === newInclusionSet?.parentInclusionSetId) {
        setInclusions = [...setInclusions, ...inclusionSet.inclusions];
        newInclusionSet = inclusionSet;
      }
    });
    return inheritedInclusions(propertyInclusionSets, newInclusionSet, setInclusions);
  }
  return setInclusions;
};
